import api from '../../utils/axios';

export const dashboardService = {
    getStats: async () => {
        const response = await api.get('/agent/dashboard');
        return response.data;
    },
    getLocations: async () => {
        const response = await api.get('/location');
        return response.data;
    },
    createVoucherAI: async (formData, config = {}) => {
        const response = await api.post('/agent/create-voucher', formData, {
            ...config,
            headers: { 
                ...config.headers,
                'Content-Type': 'multipart/form-data' 
            }
        });
        return response.data;
    },
    dismissWelcome: async () => {
        const response = await api.post('/user/dismiss-welcome');
        return response.data;
    }
};
